import api from "./helper/client";

export const getAllLeavesByTenant = async (tenantId: number) => {
    const response = await api.post("/leaves/tenant-list", { tenant_id: tenantId });
    return response;
};

export const updateLeaveStatus = async (
    tenantId: number,
    leaveId: number,
    status: string,
    approvedBy: number
) => {
    const response = await api.put("/update-leave", [
        {
            id: leaveId,
            tenant_id: tenantId,
            status,
            approved_by: approvedBy,
        },
    ]);
    return response;
};
